// ...existing code...
import React, { useEffect, useState } from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import { FaFileDownload } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
// ...existing code...

export default function OrderReceipt() {
  const location = useLocation();
  const navigate = useNavigate();

  // prefer navigate state; fallback to sessionStorage (saved by ShopperAdders)
  const [checkout, setCheckout] = useState(() => {
    const stateCheckout =
      location.state?.checkoutResponse || location.state?.checkout || location.state?.result;
    if (stateCheckout) return stateCheckout;
    try {
      const stored = sessionStorage.getItem("checkoutResponse");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const [shipping, setShipping] = useState(() => {
    const stateShipping = location.state?.shippingAddress;
    if (stateShipping) return stateShipping;
    try {
      const stored = sessionStorage.getItem("shippingAddress");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    // update from navigation state when arriving via navigate(...)
    if (location.state?.checkoutResponse || location.state?.checkout || location.state?.result) {
      setCheckout(location.state.checkoutResponse || location.state.checkout || location.state.result);
    }
    if (location.state?.shippingAddress) {
      setShipping(location.state.shippingAddress);
    }
  }, [location.state]);


  // --- NEW: fetch product images for items that don't have an image ---
  const [images, setImages] = useState({}); // map productId -> imageUrl

  useEffect(() => {
    if (!checkout?.orders?.length) return;

    const idsToFetch = new Set();

    checkout.orders.forEach((order) => {
      (order.order_items || []).forEach((it) => {
        // if item already has image or we already fetched it, skip
        if (it.image || images[it.product_id]) return;
        idsToFetch.add(it.product_id);
      });
    });

    if (idsToFetch.size === 0) return;

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") || "";

    // fetch each product detail and extract first media url
    const fetchForId = async (productId) => {
      try {
        const url = `${API_BASE_URL}/product?id=${encodeURIComponent(productId)}`;
        const res = await fetch(url, {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { token } : {}),
          },
        });
        if (!res.ok) return null;
        const json = await res.json();
        const result = json?.result;
        const img = result?.product_media?.[0]?.url || result?.image || null;
        return img;
      } catch (e) {
        return null;
      }
    };

    let mounted = true;
    (async () => {
      const updates = {};
      for (const id of idsToFetch) {
        // avoid refetching if another effect already set it
        if (images[id]) continue;
        const img = await fetchForId(id);
        if (img && mounted) updates[id] = img;
      }
      if (mounted && Object.keys(updates).length) {
        setImages((prev) => ({ ...prev, ...updates }));
      }
    })();

    return () => {
      mounted = false;
    };
  }, [checkout, images]);

  // derive useful values
  const orders = checkout?.orders || [];
  const totalAmount =
    checkout?.total_amount ??
    orders.reduce((s, o) => s + (o.pricing?.final_amount ?? 0), 0);

  if (!checkout) {
    return (
      <div className="dashboard w-full min-h-screen flex">
        <Leftsidebar />
        <main className="flex-1  p-6">
          <LeftResponsivesidebar />
          <Headmenu />
          <div className="mx-auto p-6 bg-white rounded-xl shadow-lg text-center">
            <h2 className="text-lg font-semibold mb-4">No order data available</h2>
            <p className="text-sm text-gray-600 mb-4">
              No checkout response found. You can go back to orders or home.
            </p>
            <div className="flex justify-center gap-3">
              <button onClick={() => navigate(-1)} className="px-4 py-2 border rounded">
                ← Back
              </button>
              <button onClick={() => navigate("/")} className="px-4 py-2 bg-green-700 text-white rounded">
                Continue Shopping
              </button>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />

      <main className="flex-1  p-6">
        <LeftResponsivesidebar />
        <Headmenu />
        <div className=" mx-auto p-6 bg-white rounded-xl shadow-lg">
          <div className="flex flex-col items-center mb-6">
            <div className=" rounded-full p-4 mb-3">
              <img
                src="/image/success.png"
                className="w-[100px] h=[100px]"
                alt=""
              />
            </div>
            <h2 className="text-lg font-semibold mb-1">
              Thank you! Your order has been placed.
            </h2>
            <p className="text-gray-500 mb-4 text-center">
              {checkout.message || "Your payment has been successfully done."}
            </p>
            <div className="text-center mb-2">
              <div className="text-gray-500 text-xs">Total Payment</div>
              <div className="text-2xl font-bold">${Number(totalAmount || 0).toFixed(2)}</div>
              <div className="text-xs text-gray-400">{new Date().toLocaleString()}</div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Order No</div>
              <div className="font-medium">
                {orders[0]?.order_number || `#${orders[0]?.order_id || "N/A"}`}
              </div>
            </div>
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Payment Ref No.</div>
              <div className="font-medium">{checkout.payment_intent_id || checkout.client_secret || "N/A"}</div>
            </div>
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Sender Name</div>
              <div className="font-medium">{shipping?.name || "N/A"}</div>
            </div>
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Payment Method</div>
              <div className="font-medium">{checkout.payment_method || "N/A"}</div>
            </div>
          </div>

          <div className="mb-4 border p-2 space-y-1 rounded-md">
            <div className="text-xs text-gray-500 mb-1">Shipping Details</div>
            {shipping ? (
              <div className="font-medium">
                <div>{shipping.name}</div>
                <div>
                  {shipping.address_line_1}
                  {shipping.address_line_2 ? `, ${shipping.address_line_2}` : ""}
                </div>
                <div>
                  {shipping.city} {shipping.state} {shipping.postal_code}
                </div>
                <div>{shipping.country}</div>
                <div className="mt-1">Phone: {shipping.phone}</div>
                <div>Email: {shipping.email}</div>
              </div>
            ) : (
              <div className="font-medium">
                Flat No 256, 22nd Floor, 5 Th Cross Street, Chennai – 600 023 |
                Phone No: +91 7904330323
              </div>
            )}
          </div>
          <div className="w-full flex justify-center">
            <button className="flex gap-3 rounded-full items-center justify-center bg-[#095228] hover:bg-green-800 text-white px-4 py-2 mb-6">
              <FaFileDownload className="text-xl" />
              Get PDF Receipt
            </button>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3 text-green-700">
              Items Ordered
            </h3>
           <div className=" rounded-lg  space-y-4">
              {orders.flatMap(order => order.order_items || []).map((item) => {
                const src = item.image || images[item.product_id] || "/image/shoeimg.png";
                return (
                <div key={item.id} className="border p-2 space-y-1 rounded-md">
                  <div className="flex items-center">
                    <div className=" ">
                      <img
                        src={src}
                        alt={item.product_name || "Product"}
                        className="h-[80px] w-[80px] rounded-lg mr-4 object-contain"
                      />
                    </div>

                    <div>
                      <div className="font-semibold">
                        {item.product_name || `Product ${item.product_id}`}
                      </div>
                      <div className="text-xs text-gray-500">Qty: {item.quantity}</div>
                      <div className="text-xs text-gray-500">Price: ${Number(item.unit_price || item.total_price || 0).toFixed(2)}</div>
                    </div>
                  </div>
                </div>
                );
              })}
            </div>
          </div>
          
        </div>
                    <button  onClick={() => navigate('/myorder')} className="flex gap-3 rounded-full items-center justify-center bg-[#095228] hover:bg-green-800 text-white px-4 py-2 mb-6">
              <FaFileDownload className="text-xl" />
Track Your Order            </button>

                        <button onClick={() => navigate('/')} className="flex gap-3 rounded-full items-center justify-center bg-[#095228] hover:bg-green-800 text-white px-4 py-2 mb-6">
              <FaFileDownload className="text-xl" />
Continue Shopping             </button>
      </main>
    </div>
  );
}
// ...existing code...